import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

export async function addArtwork(postData: any): Promise<any> {
  return await API.post(API_NAME, `artwork/add`, { body: postData });
}

export async function addArtworkImageResize(postData: any): Promise<any> {
  return await API.post(API_NAME, `artwork/add-image-resize`, { body: postData });
}

export async function listArtwork(postData: any): Promise<any> {
  return await API.get(API_NAME, `artwork/list?filter=${encodeURIComponent(JSON.stringify(postData))}`, {});
}

export async function viewArtwork(postData: any): Promise<any> {
  return await API.get(API_NAME, `artwork/view?artId=${postData.artId}&userId=${postData.userId}`, {});
}

export async function deleteArtwork(postData: any): Promise<any> {
  return await API.put(API_NAME, `artwork/delete`, { body: postData });
}

export async function deleteArtworkVersion(postData: any): Promise<any> {
  return await API.put(API_NAME, `artwork/delete-version`, { body: postData });
}

export async function addArtworkVersion(postData: any): Promise<any> {
  return await API.post(API_NAME, `artwork/add-version`, { body: postData });
}

export async function convertHeicToJpeg(postData: any): Promise<any> {
  return await API.post(API_NAME, `artwork/heic-convert`, { body: postData });
}